<template>
  <div>
    <v-card class="ma-2">
      <v-card-title  class="teal white--text">
        Data Perusahaan
        <v-spacer />
        <v-btn @click="editClick" v-if="isEdit == false">
          <v-icon left>edit</v-icon>
          Edit
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="form2"
            v-model="valid"
            lazy-validation
          >     
            <v-row>
              <v-col cols="6">
                <v-text-field
                  name="perusahaan"
                  type="text"
                  outlined
                  label="Nama Perusahaan"
                  v-model="perusahaan"
                  :rules="[rules.required]"
                  append-icon="check_circle"
                  :disabled="!isEdit"              
                />             
                <v-textarea
                  name="alamat"
                  outlined
                  label="Alamat Perusahaan"    
                  append-icon="check_circle"       
                  v-model="alamat"
                  counter="200"
                  :rules="[rules.required, v => v.length <= 200 || 'Max 200 characters']" 
                  height="142"
                  :disabled="!isEdit"
                ></v-textarea>
                <v-text-field
                  name="kodepos"
                  type="number"
                  outlined
                  label="Kode Pos"
                  v-model="kodepos"
                  append-icon="check_circle"
                  :rules="[rules.required, v => v.length == 5 || 'Kodepos harus 5 digit']"
                  :disabled="!isEdit"
                />  
                <v-select
                  :items="itemsProvinsi"
                  label="Provinsi"
                  outlined
                  v-model="provinsi"
                  :rules="[rules.required]"
                  append-icon="check_circle"
                  @change="provinsiChange"
                  :disabled="!isEdit"
                ></v-select>
                <v-select
                  :items="itemsKabKota"
                  label="Kabupaten / Kota"
                  outlined
                  v-model="kabKota"
                  :rules="[rules.required]"
                  append-icon="check_circle"
                  :disabled="!isEdit"
                ></v-select>  
                <v-text-field
                  name="telepon"
                  type="text"
                  outlined
                  label="Telepon"
                  v-model="telepon"
                  :rules="[rules.required]"
                  append-icon="check_circle"
                  :disabled="!isEdit"
                />               
                <v-text-field
                  name="fax"
                  type="text"
                  outlined
                  label="Fax"
                  v-model="fax"
                  :disabled="!isEdit"
                />          
                <v-text-field
                  name="email"
                  type="text"
                  outlined
                  label="E-Mail"
                  v-model="email"
                  :disabled="!isEdit"
                />      
                <v-text-field
                  name="website"
                  type="text"
                  outlined
                  label="Website"
                  v-model="website"
                  :disabled="!isEdit"
                />                              
              </v-col>
              <v-col cols="6">    
                <v-select
                  :items="itemsBentukUsaha"
                  label="Bentuk Usaha"
                  outlined
                  v-model="bentukUsaha"
                  :rules="[rules.required]"
                  append-icon="check_circle"
                  :disabled="!isEdit"
                ></v-select>
                <v-text-field
                  v-model="npwp"
                  type="text"
                  label="No. NPWP"
                  append-icon="check_circle"       
                  :disabled="!isEdit"      
                  :rules="[rules.required]"
                  v-mask="'##.###.###.#-###.###'"
                  placeholder="00.000.000.0-000.000"
                  outlined
                />                      
                <v-text-field
                  v-model="pengNpkp"
                  type="text"
                  outlined
                  label="No. Pengukuhan PKP"
                  append-icon="check_circle" 
                  :disabled="!isEdit"
                  @change="pengPKPChange"
                />  

                <!--
                <v-text-field
                  name="pkp"
                  type="text"
                  outlined
                  label="No. PKP"
                  v-model="pkp"
                  :rules="[]"        
                  append-icon="check_circle"
                  :disabled="!isEdit"
                />  
                -->

                <!-- FILE SKPKP -->
                <v-file-input
                  name="skPkp"
                  accept=".jpg,.png,.pdf"
                  label="SK No. PKP"
                  v-model="skPkp"
                  chips
                  outlined
                  :rules="[validateUploadFileSkpkp()]"        
                  :disabled="!isEdit"
                  :placeholder="filenameSKPKP"
                  append-icon="get_app"
                  @click:append="getLinkDownload(filenameSKPKP)"
                  @keyup.delete="skPkpDelete"
                  clearable
                />
              <div style="margin-top:-30px;margin-left:30px">*Maksimal ukuran file 3mb</div>


                <v-checkbox v-model="cabang" label="Kantor Cabang ?" :disabled="!isEdit"></v-checkbox>
                <v-textarea
                  name="alamatPusat"
                  outlined
                  label="Alamat Kantor Pusat"    
                  append-icon="check_circle"       
                  v-model="alamatPusat"
                  counter="200"
                  :rules="[rules.requiredCabang(cabang), v => v.length <= 200 || 'Max 200 characters']" 
                  height="142"
                  :disabled="!cabang || !isEdit"
                ></v-textarea>
                <v-text-field
                  name="teleponPusat"
                  type="text"
                  outlined
                  label="Telepon Kantor Pusat"
                  v-model="teleponPusat"
                  :rules="[rules.requiredCabang(cabang)]"
                  append-icon="check_circle"
                  :disabled="!cabang || !isEdit"
                />               
                <v-text-field
                  name="faxPusat"
                  type="text"
                  outlined
                  label="Fax Kantor Pusat"
                  v-model="faxPusat"
                  :disabled="!cabang || !isEdit"
                />          
                <v-text-field
                  name="emailPusat"
                  type="text"
                  outlined
                  label="E-Mail Kantor Pusat"
                  v-model="emailPusat"
                  :disabled="!cabang || !isEdit"
                />
              </v-col>
            </v-row>    

            <v-row>
              <v-col>
                <v-file-input
                  v-model="fileFormulir"
                  accept=".jpg,.png,.pdf,.docx"
                  label="Formulir Keikutsertaan"
                  chips
                  outlined
                  :disabled="!isEdit"
                  :placeholder="filenameFormulir"
                  :rules="[validateUploadFileFormulir()]"
                  append-icon="get_app"
                  @click:append="getLinkDownload(filenameFormulir)"
                  clearable
                />
              </v-col>
              <v-col>
                <v-file-input
                  v-model="fileNonPKP"
                  accept=".jpg,.png,.pdf,.docx"
                  label="Surat Pernyataan Non PKP"
                  chips
                  outlined
                  :disabled="!isEdit || isPKP"
                  :placeholder="filenameNonPKP"
                  :rules="[validateUploadFileNonPKP()]"
                  append-icon="get_app"
                  @click:append="getLinkDownload(filenameNonPKP)"
                  @keyup.delete="nonPkpDelete"
                  clearable
                />
              </v-col>
            </v-row>

            <v-divider v-if="isEdit" />
            <v-row v-if="isEdit">
              <v-col cols="12">
                <v-btn color="success" dark @click.prevent="simpan2Click">
                  Simpan
                </v-btn>
                <v-btn class="mx-2" color="warning" dark @click.prevent="isEdit = false">
                  Batal
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import { rules as Rules } from './../../lib/rules'
import { itemsBentukUsaha as itBentukUsaha, provinsi as prov, daerah } from "./../../lib/viewLib"
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  data: function() {
    return {
      valid: true,
      perusahaan: '',      
      npwp: '',
      pengNpkp: '',
      pkp: '',
      skPkp: null,
      email: '',
      website: '',
      alamat: '',
      kodepos: '',      
      telepon: '',
      fax: '',      
      cabang: false,
      provinsi: '',
      kabKota: '',
      bentukUsaha: '',
      // kantor pusat
      alamatPusat: '',
      teleponPusat: '',
      faxPusat: '',
      emailPusat: '',
      fileFormulir: null,
      fileNonPKP: null,
      rules: {
        required: Rules.required,
        requiredCabang: Rules.requiredCabang,
        email: Rules.email,
      },
      // items untuk select
      itemsBentukUsaha: itBentukUsaha,
      itemsProvinsi: prov,
      itemsKabKota: [],
      isEdit: false,
      filenameSKPKP: "",
      filenameFormulir: "",
      filenameNonPKP: "",
      isPKP: false,

      submitting: false,
    }
  },
  computed: {
    venId: function() { 
      return this.$store.getters['ven/venId']
    }
  },
  methods: {
    getLinkDownload: function(dok) {
      axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },

    validateUploadFileSkpkp() {
      if (this.pengNpkp == null || this.pengNpkp === "") return true;
      if (this.isEdit && this.filenameSKPKP != "") return true;
      return this.skPkp != null || "Dokumen SK No. PKP wajib di-upload jika No. PKP diisi";
    },

    validateUploadFileFormulir() {
      if (this.isEdit && this.filenameFormulir !== "") return true;
      return this.fileFormulir != null || "Formulir keikutsertaan wajib dilampirkan"
    },

    validateUploadFileNonPKP() {
      if (this.pengNpkp !== "") return true;
      if (this.skPkp != null || this.filenameSKPKP !== "") return true;
      if (this.isEdit && this.filenameNonPKP !== "") return true;
      return this.fileNonPKP != null || "Surat pernyataan Non PKP wajib dilampirkan jika tidak melampirkan PKP";
    },

    pengPKPChange() {
      if (this.pengNpkp != null && this.pengNpkp !== '') {
        this.isPKP = true
        this.fileNonPKP = null
        this.filenameNonPKP = ''
      }
      else {
        this.isPKP = false
        this.skPkp = null
        this.filenameSKPKP = ''
      }
    },

    skPkpDelete() {
      this.filenameSKPKP = ''
      this.skPkp = null
    },

    nonPkpDelete() {
      this.filenameNonPKP = ''
      this.fileNonPKP = null
    },

    provinsiChange: function() {
      this.kabKota = ''
      this.itemsKabKota = daerah.find(({provinsi}) => provinsi === this.provinsi).kabKota
    },
    editClick: function() {
      this.isEdit = true
    },
    simpan2Click: async function() {
      if (this.$refs.form2.validate()) { // validasi input
        // buat message
        const fdata = new FormData()
        fdata.append('perusahaan', this.perusahaan)
        fdata.append('alamat', this.alamat)
        fdata.append('kodepos', this.kodepos)
        fdata.append('provinsi', this.provinsi)
        fdata.append('kabKota', this.kabKota)
        fdata.append('telepon', this.telepon)
        fdata.append('fax', this.fax)
        fdata.append('email', this.email)
        fdata.append('website', this.website)      
        fdata.append('bentukUsaha', this.bentukUsaha)
        fdata.append('npwp', this.npwp)
        fdata.append('pengNpkp', this.pengNpkp)
        fdata.append('pkp', this.pkp)
        fdata.append('cabang', this.cabang.toString())
        if (this.cabang) {
          fdata.append('dataPusat', JSON.stringify({
            alamatPusat: this.alamatPusat,
            teleponPusat: this.teleponPusat,
            faxPusat: this.faxPusat,
            emailPusat: this.emailPusat,
          }))
        }
        else {
          fdata.append('dataPusat', '')
        }    
        fdata.append('vendorId', this.venId)
        fdata.append('emailR', this.$store.getters.userInfo.email)        
        fdata.append('skPkp', this.skPkp)
        fdata.append('fileNonPKP', this.fileNonPKP);        
        fdata.append('fileFormulir', this.fileFormulir);
        fdata.append('filenameFormulir', this.filenameFormulir)
        fdata.append('filenameSKPKP', this.filenameSKPKP)
        fdata.append('filenameNonPKP', this.filenameNonPKP)

        // simpan ke database
        if (this.venId == -999) { // create new
          this.$store.dispatch('displayProgBar')      
          this.submitting = true;

          axios.post(apiUrl + '/vendor/registrasi/perusahaan', fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
          .then((response) => {
            this.$store.dispatch('displayAlert', {
              color: 'success', 
              message: `Data perusahaan telah tersimpan !` })
            this.$store.dispatch('ven/assignVendor', response.data.data)
            this.$store.commit('setStatusPerusahaan', 'V')
            this.isEdit = false;
            this.filenameSKPKP = response.data.data.skPkp;
            this.filenameFormulir = response.data.data.fileFormulir;
            this.filenameNonPKP = response.data.data.fileNonPKP;
            window.scroll(0,0)
          })
          .catch((err) => {
            console.log(err)
            this.$store.dispatch('displayAlert', {color: 'error', message: err.response.data.message})
            window.scroll(0,0)
          })
          .finally(() => {
            this.$store.dispatch('closeProgBar')
            this.submitting = false;
          })        
        }
        else { // update
          this.$store.dispatch('displayProgBar') 
          this.submitting = true;

          axios.post(apiUrl + '/vendor/registrasi/perusahaan/update', fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
          .then((response) => {
            this.$store.dispatch('displayAlert', {
              color: 'success', 
              message: `Data perusahaan telah berhasil diupdate !` })
            this.$store.dispatch('ven/assignVendor', response.data.data)
            this.isEdit = false
            this.filenameSKPKP = response.data.data.skPkp;
            this.filenameFormulir = response.data.data.fileFormulir;
            this.filenameNonPKP = response.data.data.fileNonPKP;
            window.scroll(0,0)
          })
          .catch((err) => {
            console.log(err)
            this.$store.dispatch('displayAlert', {color: 'error', message: err})
            window.scroll(0,0)
          })
          .finally(() => {
            this.$store.dispatch('closeProgBar')
            this.submitting = false;
          })  
        }
      }
    },
  },
  created: function() {
    this.$store.dispatch('displayPageTitle', 'Data Perusahaan')
    if (this.venId == -999) {
      this.isEdit = true
    }
    else {
      axios.get(`${apiUrl}/vendor/registrasi/perusahaan/${this.venId}`)
      .then((response) => {        
        this.perusahaan = response.data.data.nama    
        this.npwp = response.data.data.npwp   
        this.pengNpkp = response.data.data.noPengukuhan
        this.pkp = response.data.data.pkp
        this.skPkp = null
        this.email = response.data.data.email
        this.website = response.data.data.website
        this.alamat = response.data.data.alamat
        this.kodepos = response.data.data.kodepos    
        this.telepon = response.data.data.telepon
        this.fax= response.data.data.fax   
        this.cabang = response.data.data.cabang
        this.provinsi = response.data.data.provinsi
        this.itemsKabKota = daerah.find(({provinsi}) => provinsi === this.provinsi).kabKota
        this.kabKota = response.data.data.kabkod
        this.bentukUsaha = response.data.data.bentuk
        this.fileFormulir = null;
        this.fileNonPKP = null;
        // kantor pusat
        if (response.data.data.pusat !== '') {
          const dataPusat = JSON.parse(response.data.data.pusat)
          this.alamatPusat = dataPusat.alamatPusat
          this.teleponPusat = dataPusat.teleponPusat
          this.faxPusat = dataPusat.faxPusat
          this.emailPusat = dataPusat.emailPusat
        }

        this.filenameSKPKP = response.data.data.skPkp;
        console.log("Filename SKPKP: ", this.filenameSKPKP);
        this.filenameFormulir = response.data.data.fileFormulir;
        console.log("Filename Formulir: ", this.filenameFormulir);
        this.filenameNonPKP = response.data.data.fileNonPKP;
        console.log("Filename Non PKP: ", this.filenameNonPKP);

        this.$store.dispatch('ven/assignVendor', { id: response.data.data.id, name: response.data.data.nama, status: response.data.data.status })
        this.isPKP = this.pengNpkp !== ''
      })
      this.isEdit = false
    }
  }
}
</script>

<style scoped>

</style>